
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/error",
      function () {
        return require("private-next-pages/error.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/error"])
      });
    }
  